import { render, staticRenderFns } from "./PlatformSelector.vue?vue&type=template&id=5d7b3d6c&scoped=true"
import script from "./PlatformSelector.vue?vue&type=script&lang=js"
export * from "./PlatformSelector.vue?vue&type=script&lang=js"
import style0 from "./PlatformSelector.vue?vue&type=style&index=0&id=5d7b3d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b3d6c",
  null
  
)

export default component.exports